import React,{useContext} from 'react';
//import Logo2 from '../../../assets/img/logo2.jpg'
import Logo1 from '../../../assets/img/logo1.jpg'
import Logo2 from '../../../assets/img/02.jpg'
import Logo3 from '../../../assets/img/03.jpg'
import Logo4 from '../../../assets/img/04.jpg'
import Logo5 from '../../../assets/img/05.jpg'
import Logo6 from '../../../assets/img/06.png'
import './style.scss'
//import { UserGlobalContextMemorySpace } from '../../../contexts/user/userGlobalContext';
import { GlobalContextMemorySpace } from '../../../context/globalContext';

const LogosCoporativosComponent = () => {
  const {footerConfiguration} = useContext(GlobalContextMemorySpace);  
return(  
  <>
    <section style={{backgroundColor:"#ededed",height:"3vh"}}></section>
    <section className="section-logos bg-white">
    <div className="container">
      <div className="row pt-3 pb-3 pr-3 d-flex justify-content-center align-items-center">
        <div className="col-4 col-md text-center">
          <a href={footerConfiguration?.data_fiscal} target="_blank"><img src={Logo1} alt="Data Fiscal" className="logosFooter" /></a>        
        </div>
        <div className="col-4 col-md text-center">
        <a href={footerConfiguration?.registro_nacional} target="_blank"><img src={Logo2} alt="Registro Nacional" className="logosFooter" /></a>
        </div>
        <div className="col-4 col-md text-center">
        <a href={footerConfiguration?.itaes} target="_blank"><img id="itaes" src={Logo3} alt="ITAES" className="logosFooter" /></a>
        </div>
        <div className="col-4 col-md text-center">
        <a href={footerConfiguration?.red_global} target="_blank"><img src={Logo4} alt="Red Global" className="logosFooter" /></a>
        </div>
        <div className="col-4 col-md text-center">
        <a href={footerConfiguration?.consejo_argentino} target="_blank">
          <img src={Logo5} alt="Consejo Argentino" className="logosFooter" />
        </a>
        </div>
        <div className="col-4 col-md text-center">          
        <a href={footerConfiguration?.safe_travels}><img src={Logo6} alt="Safe Travels" className="logosFooter" id="safe-travel" /></a>
        </div>
      </div>
    </div>
  </section>
  </>
);
}
export default LogosCoporativosComponent;